const { Text } = require('account-ui');
const { inputText, blurText } = require('../../../../../signals/form');

class Filter {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data));
    }
}

module.exports = {
    constructor: Filter,
    children: [
        {
            name: 'filter-input',
            component: Text,
            props: {
                signals: { inputText, blurText },
                position: 'leftToRight',
                placeholder: 'Отфильтровать...'
            },
            watcher: {
                value: ['account', 'users', 'list', 'filter']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/users/users-list/users-filter/index.js